import { themeClasses } from '@member-portal/ui';
import { useAuth } from '@/contexts/AuthContext';
import MembersOnlyOverlay from '@/components/MembersOnlyOverlay';

interface PastIssue {
  title: string;
  url: string;
  coverImage: string;
}

const pastIssues: PastIssue[] = [
  {
    title: 'The Indulge Issue 2026',
    url: 'https://issuu.com/fourhundredbydesign/docs/insider_indulge_2026?fr=sYTc5ZTkyMjc5OTM',
    coverImage: '/images/insider/2026-q1-indulge.jpg',
  },
  {
    title: 'The Celebrations Issue 2026',
    url: 'https://issuu.com/fourhundredbydesign/docs/2026-q1-insider-celebrations',
    coverImage: '/images/insider/2026-q1-celebrations.jpg',
  },
  {
    title: 'The Design Issue 2025',
    url: 'https://issuu.com/fourhundredbydesign/docs/2025-q4-insider-design?fr=sNDVkNjg4NTM1NDA',
    coverImage: '/images/insider/2025-q4-design.jpg',
  },
  {
    title: 'The Favorites Issue 2025',
    url: 'https://issuu.com/fourhundredbydesign/docs/insider_favorites_2025?fr=sNGVjMTg4NTM1NDA',
    coverImage: '/images/insider/2025-q3-favorites.jpg',
  },
  {
    title: 'The Indulge Issue 2025',
    url: 'https://issuu.com/fourhundredbydesign/docs/insider_indulge_2025?fr=sN2EzZjg2ODI2OTQ',
    coverImage: '/images/insider/2025-q2-indulge.jpg',
  },
  {
    title: 'The Secrets Issue 2025',
    url: 'https://issuu.com/fourhundredbydesign/docs/insider-25q1-secrets?fr=xPf_q6uo',
    coverImage: '/images/insider/2025-q1-secrets.jpg',
  },
  {
    title: 'The Design Issue 2024',
    url: 'https://issuu.com/fourhundredbydesign/docs/2024-q4-insider-design?fr=xPf_q6uo',
    coverImage: '/images/insider/2024-q4-design.jpg',
  },
  {
    title: 'Favorites 2024',
    url: 'https://issuu.com/fourhundredbydesign/docs/insider-favorites-2024?fr=xPf_q6uo',
    coverImage: '/images/insider/2024-q3-favorites.jpg',
  },
  {
    title: 'Indulge 2024',
    url: 'https://issuu.com/fourhundredbydesign/docs/insider-indulge-2024?fr=sZjMzNDY3MjY5MTk',
    coverImage: '/images/insider/2024-q2-indulge.jpg',
  },
  {
    title: 'Wellness Wakeup 2024',
    url: 'https://issuu.com/fourhundredbydesign/docs/2024-q1-insider-wellness-wakeup?fr=sMmIyODY3MjY5MTk',
    coverImage: '/images/insider/2024-q1-wellness.jpg',
  },
  {
    title: 'The Indulge Issue 2023',
    url: 'https://issuu.com/fourhundredbydesign/docs/insider-indulge-2023-fhxd?fr=xPf_j4-M',
    coverImage: '/images/insider/2023-q4-indulge.jpg',
  },
  {
    title: 'The Design Issue 2023',
    url: 'https://issuu.com/fourhundredbydesign/docs/insider-design-2023-fhxd?fr=sMmM3YzY3MjY5MTk',
    coverImage: '/images/insider/2023-q3-design.jpg',
  },
  {
    title: 'Secret Places 2023',
    url: 'https://issuu.com/fourhundredbydesign/docs/fhxd_insider_secret_places?fr=sOTk3MzYwMTA0NzM',
    coverImage: '/images/insider/2023-q2-secret-places.jpg',
  },
  {
    title: 'Romance 2023',
    url: 'https://issuu.com/fourhundredbydesign/docs/fhxd-insider-romance?fr=sZTQxZTYwMTA0Njk',
    coverImage: '/images/insider/2023-q1-romance.jpg',
  },
  {
    title: 'City Centric, City Centered 2022',
    url: 'https://issuu.com/fourhundredbydesign/docs/insider-city_centered-v2-links?fr=sZTMzYzUyOTE0NjM',
    coverImage: '/images/insider/2022-q4-city-centric.jpg',
  },
  {
    title: 'The Design Issue 2022',
    url: 'https://issuu.com/fourhundredbydesign/docs/2022-03-insider-design-fhxd?fr=sNDY2NDUyOTE0NjM',
    coverImage: '/images/insider/2022-q3-design.jpg',
  },
  {
    title: 'Summer Family Travel 2022',
    url: 'https://issuu.com/fourhundredbydesign/docs/2022-02-insider-summer-family-travel-draft-06?fr=sNGM5MTUyOTE0NjM',
    coverImage: '/images/insider/2022-q2-summer-family.jpg',
  },
  {
    title: 'Wellness Wakeup 2022',
    url: 'https://issuu.com/fourhundredbydesign/docs/insider-winter-2022-f07?fr=sM2UxMTQzODY3MDU',
    coverImage: '/images/insider/2022-q1-wellness.jpg',
  },
  {
    title: 'Fall 2021',
    url: 'https://issuu.com/fourhundredbydesign/docs/insider_fall_2021_final_05_-_member?fr=sMjFiZDQzODY3MDU',
    coverImage: '/images/insider/2021-q4-fall.jpg',
  },
  {
    title: 'Summer 2021',
    url: 'https://issuu.com/fourhundredbydesign/docs/summer_21_lookbook_final_6?fr=sZTBmMjQzODY3MDU',
    coverImage: '/images/insider/2021-q3-summer.jpg',
  },
  {
    title: 'Spring 2021',
    url: 'https://issuu.com/fourhundredbydesign/docs/2021_fxh_spring_draft2_v3?fr=sOWMzOTQzODY3MDU',
    coverImage: '/images/insider/2021-q2-spring.jpg',
  },
];

function InsiderPage() {
  const { isAuthenticated } = useAuth();

  return (
    <div className="fhxd-chrome-top">
      {/* Hero Section */}
      <section className="relative py-24 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url(/images/images/agnieszka-stankiewicz-h7Vf6TriiWw-unsplash.jpg)' }}
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-title font-normal text-3xl md:text-5xl lg:text-7xl tracking-wider uppercase text-white mb-4">
            Insider Magazine
          </h1>
          <p className="font-body font-normal text-xl md:text-2xl tracking-form text-white/80">
            The Secrets Issue 2026
          </p>
        </div>
      </section>

      {/* Magazine Embed Section */}
      <section className="py-16 bg-theme-bg">
        <div className={themeClasses.container}>
          <div className="relative" style={{ paddingTop: 'max(60%,326px)', height: 0, width: '100%' }}>
            <iframe
              allow="clipboard-write"
              sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox allow-forms"
              allowFullScreen={true}
              style={{
                position: 'absolute',
                border: 'none',
                width: '100%',
                height: '100%',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
              }}
              src="https://e.issuu.com/embed.html?backgroundColor=%23f3f3f3&d=insider_-_secrets_2026&hideIssuuLogo=true&u=fourhundredbydesign"
            />

          </div>

          {/* Fullscreen Link */}
          <div className="mt-6">
            <a
              href="https://issuu.com/fourhundredbydesign/docs/insider_-_secrets_2026?fr=sM2M4NDkzNjA1OTQ"
              target="_blank"
              rel="noopener noreferrer"
              className={`${themeClasses.text.body} text-theme-text hover:text-theme-text-muted transition-colors underline`}
            >
              The Secrets Issue 2026 — Fullscreen Experience
            </a>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className={themeClasses.container}>
        <div className="h-[2px] w-full bg-theme-border" />
      </div>

      {/* Past Issues Section */}
      <section className="py-16 bg-theme-bg">
        <div className={themeClasses.container}>
          <h2 className={`${themeClasses.title.h3} mb-12`}>Past Issues</h2>

          <div className="relative min-h-[400px]">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
              {pastIssues.map((issue, index) => (
                <a
                  key={index}
                  href={issue.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group block"
                >
                  <div className="relative overflow-hidden mb-4 shadow-md hover:shadow-lg transition-shadow duration-300">
                    <img
                      src={issue.coverImage}
                      alt={issue.title}
                      className="w-full aspect-[4/5] object-cover group-hover:scale-105 transition-transform duration-300"
                      loading="lazy"
                    />
                  </div>
                  <h4 className={`${themeClasses.title.h5} group-hover:text-theme-text-muted transition-colors`}>
                    {issue.title}
                  </h4>
                </a>
              ))}
            </div>

            {/* Blur Overlay for Non-Authenticated Users */}
            {!isAuthenticated && (
              <MembersOnlyOverlay message="Log in or sign up to access past issues." />
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default InsiderPage;
